<template>
<div>
  <component :is="item.component" :item="item"/>
</div>
</template>

<script>
export default {
  name: 'QuestionnaireItem',
  components: {
    LikertQuestionInput: () => import('@/components/appUser/questionnaires/pageItems/QuestionLikertItem'),
    MCQQuestionInput: () => import('@/components/appUser/questionnaires/pageItems/QuestionMCItem'),
    OpenQuestionInput: () => import('@/components/appUser/questionnaires/pageItems/QuestionOpenItem'),
    RichTextInput: () => import('@/components/appUser/questionnaires/pageItems/RichTextItem'),
    TitleInput: () => import('@/components/appUser/questionnaires/pageItems/TitleItem')
  },
  props: {
    item: {
      required: true,
      type: Object
    }
  }
}
</script>
